<template>
    <el-form :inline="true" :model="searchParams" class="school-ability-search-form">
        <el-row :gutter="3">
            <!-- 动态渲染表单字段 -->
            <el-col v-for="field in fields" :key="field.prop" :span="field.span" class="form-col">
                <el-form-item :key="field.prop" :label="field.label" :prop="field.prop" class="form-item">
                    <div class="form-item-inner">

                        <!-- 判断字段类型 -->
                        <template v-if="field.type === 'input'">
                            <el-input v-model="searchParams[field.prop]" :placeholder="field.placeholder" clearable
                                class="input-field">
                                <!-- 如果是输入框支持附加按钮 -->
                                <template #append v-if="field.appendIcon">
                                    <el-button :icon="field.appendIcon" circle @click="triggerSearch"></el-button>
                                </template>
                            </el-input>
                        </template>
                        <template v-else-if="field.type === 'select'">
                            <el-select collapse-tags v-model="searchParams[field.prop]" :placeholder="field.placeholder"
                                :multiple="field.multiple || false" :clearable="field.clearable || true"
                                @change="handleFieldChange(field, searchParams[field.prop])" class="input-field">
                                <el-option v-for="option in field.options" :key="option.value" :label="option.label"
                                    :value="option.value" />
                            </el-select>
                        </template>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import { debounce } from "@/util/util";


export default {
    name: "schoolAbility",
    props: {
        fields: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            searchParams: this.initializeSearchParams(),
        };
    },
    methods: {
        // 初始化搜索参数
        initializeSearchParams() {
            const params = {};
            this.fields.forEach((field) => {
                params[field.prop] = field.default || (field.multiple ? [] : ""); // 初始化多选为空数组
            });
            return params;
        },
        // 动态更新字段选项内容
        updateFieldOptions(fieldProp, newOptions) {
            const field = this.fields.find((f) => f.prop === fieldProp);
            if (field) {
                this.searchParams[fieldProp] = []
                field.options = newOptions;
            }
        },
        // 处理字段变化
        async handleFieldChange(field, value) {
            if (field.onChange) {
                await field.onChange(value, this.updateFieldOptions); // 调用配置中的 onChange 回调
            }
            this.triggerSearch();
        },
        // 触发搜索事件
        triggerSearch: debounce(function () {
            this.$emit("search", this.searchParams)
        }, 100, false)
    },
};
</script>

<style lang="scss">
.school-ability-search-form {
    padding: 30px;
    width: 100%;
    padding-bottom: 0;
    .el-form-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
    }

    .form-item-inner {
        display: flex;
        align-items: center;
        width: 100%;
    }

    .el-form-item__label {
        margin-right: 10px;
        flex-shrink: 0;
        white-space: nowrap;
        min-width: 90px;
        /* 为label添加最小宽度 */
    }

    .el-form-item__content {
        flex-grow: 1;
    }

    .input-field {
        flex-grow: 1 !important;
        /* 确保输入框或选择框扩展 */
    }

    .el-col {
        padding: 0 5px;
        box-sizing: border-box;
    }

    .form-col {
        padding: 0;
    }

    @media (max-width: 768px) {
        .school-ability-search-form .el-col {
            padding-left: 5px;
            padding-right: 5px;
        }
    }
}
</style>
